import { Button, cn } from "@tellescope/design-system";
import { Trash } from "lucide-react";

export interface ContentCardProps {
  title: string;
  type?: string;
  onDelete?: () => void;
  deleteLabel?: string;
  className?: string;
}

export const ContentCard = ({ title, type, onDelete, deleteLabel, className }: ContentCardProps) => {
  return (
    <div
      className={cn(
        // `text-left` because the enclosing BlockContent renders children inside a <button> in
        // non-edit mode, whose UA `text-align: center` would otherwise center these rows.
        "group/content flex flex-col gap-1 rounded-lg border bg-background px-4 py-3 text-left",
        className
      )}
      data-testid="contact-details-block-item"
    >
      <p className="truncate text-sm text-foreground">{title}</p>

      <div className="flex items-end justify-between gap-4">
        <p className="min-w-0 truncate text-xs text-muted-foreground">{type}</p>
        {onDelete && (
          <Button
            variant="ghost"
            color="muted"
            size="sm"
            iconOnly
            hoverLabel={deleteLabel}
            className="-my-1 shrink-0 opacity-0 transition-opacity group-hover/content:opacity-100"
            onClick={onDelete}
          >
            <Trash />
          </Button>
        )}
      </div>
    </div>
  );
};
